import Header from '@components/Header';
import TabItem from '@components/tab/TabItem';
import TabList from '@components/tab/TabList';
import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useStepFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

import EventList from './components/EventList';
import NoticeList from './components/NoticeList';

interface Params {
    type: 'EVENT' | 'NOTICE';
}

declare module '@stackflow/config' {
    interface Register {
        BoardActivity: Params;
    }
}

const BoardActivity: ActivityComponentType<'BoardActivity'> = ({ params }) => {
    const { type } = params;
    const { t } = useTranslation('board');
    const { replaceStep } = useStepFlow('BoardActivity');
    return (
        <AppScreen>
            <Header title={t('header')} />
            <TabList variant='solid'>
                <TabItem selected={type === 'EVENT'}
                    onClick={() => replaceStep({ type: 'EVENT' })}>
                    {t('tabs.event')}
                </TabItem>
                <TabItem selected={type === 'NOTICE'}
                    onClick={() => replaceStep({ type: 'NOTICE' })} >
                    {t('tabs.notice')}
                </TabItem>
            </TabList>
            {type === 'EVENT' && (
                <EventList/>
            )}
            {type === 'NOTICE' && (
                <NoticeList/>
            )}
        </AppScreen>
    );
};

export default BoardActivity;
